import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=ab15f798&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=ts&"
export * from "./Registration.vue?vue&type=script&lang=ts&"
import style0 from "./Registration.vue?vue&type=style&index=0&id=ab15f798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab15f798",
  null
  
)

export default component.exports